<template>
<div>
 <Header @getLanguageMap='getLanguageMap'></Header>
<!-- <div class="crumbs" style="padding-top: 120px;">
  <div class="container">
    <p class="title">{{languageMap['联系我们']}}</p>
    <div class="childs"> <a href="/#/">{{languageMap['主页']}}</a> &gt; <a href="/#/lianxi/">{{languageMap['联系我们']}}</a> &gt;  </div>
  </div>
</div> -->
<NavigationBar></NavigationBar>
<!-- <img src="/images/bg.png" style="position: absolute;width: 100%;left: 0px;" id="bgId"/> -->
<img v-if="languageMap['fileName']=='chinese.txt'" src="/images/bg_lx_ch.png" style="width: 100%;left: 0px;" id="bgId"/>
<img v-else src="/images/bg_lx_en.png" style="width: 100%;left: 0px;" id="bgId"/>

<div class="main">
  <div class="container">
    <!-- <div class="maxTitle"> <span class="title">{{languageMap['联系我们']}}</span>
      <div class="sub"></div>
    </div>

<br> -->

    <div class="content"> 
		<div class="bjBg" >
			<div style="width: 85%;height: 170px;margin-top: 44px;margin-left: 130px;float: left;">
			  <div v-if="block1_gs">	
				<div style="font-size: 30px;">{{languageMap[block1_gs.title]}}</div>
				<div style="font-size: 14px;color: #565656;margin-top: 25px;">{{languageMap['地址']}}（ADD）：{{languageMap[block1_gs.address]}}</div>
				<div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['电话']}}（TEL）：{{block1_gs.phone}}  <span style="margin-left: 30px;">{{block1_gs.fax}}</span> （{{languageMap['传真']}}）</div>
				<div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['邮箱']}}（E-MAIL）：{{block1_gs.email}}</div>
			  </div>
			</div>
			
          <div style="width: 85%;height: 185px;margin-top: 55px;margin-left: 130px;float: left;">
			<div class="blockC" v-for="(item,index) in block1" :key="index">
			  <div style="font-size: 14px;color: #565656;margin-top: 53px;">{{languageMap['联系人']}}：{{languageMap[item.contacts]}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['电话']}}：{{item.phone}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['邮箱']}}：{{item.email}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">QQ：{{item.qq}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;" v-if="item.skype">Skype：{{item.skype}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;" v-if="item.jsfzr">{{languageMap['技术负责人']}}：{{languageMap[item.jsfzr]}}</div>
			</div>
     	    
		  </div>
		</div>
		<div class="szBg">
			<div style="width: 97%;height: 130px;margin-top: 44px;margin-left: 10px;float: left;">
			  <div v-if="block2_gs">
				<div style="font-size: 30px;">{{languageMap[block2_gs.title]}}</div>
				<div style="font-size: 14px;color: #565656;margin-top: 25px;">{{languageMap['地址']}}（ADD）：{{languageMap[block2_gs.address]}}</div>
				<div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['电话']}}（TEL）：{{block2_gs.phone}}  <span style="margin-left: 30px;">{{block2_gs.fax}}</span> （{{languageMap['传真']}}）</div>
			  </div>	
			</div>
			
          <div style="width: 97%;height: 185px;margin-top: 55px;margin-left: 10px;float: left;">
			<div class="blockC" style="width: 190px;" v-for="(item,index) in block2" :key="index">
			  <div style="font-size: 14px;color: #565656;margin-top: 0px;">{{languageMap['联系人']}}：{{languageMap[item.contacts]}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['电话']}}：{{item.phone}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['邮箱']}}：{{item.email}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">QQ：{{item.qq}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;" v-if="item.skype">Skype：{{item.skype}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;" v-if="item.jsfzr">{{languageMap['技术负责人']}}：{{languageMap[item.jsfzr]}}</div>
			</div>
     	    
          </div>	
		</div>
		<div class="shBg">
			<div style="width: 97%;height: 130px;margin-top: 44px;margin-left: 10px;float: left;">
			  <div v-if="block3_gs">	
				<div style="font-size: 30px;">{{languageMap[block3_gs.title]}}</div>
				<div style="font-size: 14px;color: #565656;margin-top: 25px;">{{languageMap['地址']}}（ADD）：{{languageMap[block3_gs.address]}}</div>
				<div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['电话']}}（TEL）：{{block3_gs.phone}}  <span style="margin-left: 30px;">{{block3_gs.fax}}</span> （{{languageMap['传真']}}）</div>
			  </div>	
			</div>
			
          <div style="width: 97%;height: 185px;margin-top: 55px;margin-left: 10px;float: left;">
			<div class="blockC" style="width: 190px;" v-for="(item,index) in block3" :key="index">
			  <div style="font-size: 14px;color: #565656;margin-top: 0px;">{{languageMap['联系人']}}：{{languageMap[item.contacts]}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['电话']}}：{{item.phone}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['邮箱']}}：{{item.email}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">QQ：{{item.qq}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;" v-if="item.skype">Skype：{{item.skype}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;" v-if="item.jsfzr">{{languageMap['技术负责人']}}：{{languageMap[item.jsfzr]}}</div>
			</div>
			
          </div>
		</div>
		<div class="cqBg">
			<div style="width: 97%;height: 130px;margin-top: 44px;margin-left: 10px;float: left;">
			  <div v-if="block4_gs">		
				<div style="font-size: 30px;">{{languageMap[block4_gs.title]}}</div>
				<div style="font-size: 14px;color: #565656;margin-top: 25px;">{{languageMap['地址']}}（ADD）：{{languageMap[block4_gs.address]}}</div>
				<div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['电话']}}（TEL）：{{block4_gs.phone}}  <span style="margin-left: 30px;">{{block4_gs.fax}}</span> （{{languageMap['传真']}}）</div>
			  </div>	
			</div>
			
          <div style="width: 97%;height: 185px;margin-top: 55px;margin-left: 10px;float: left;">
			  <div class="blockC" style="width: 190px;" v-for="(item,index) in block4" :key="index">
			  <div style="font-size: 14px;color: #565656;margin-top: 0px;">{{languageMap['联系人']}}：{{languageMap[item.contacts]}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['电话']}}：{{item.phone}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['邮箱']}}：{{item.email}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">QQ：{{item.qq}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;" v-if="item.skype">Skype：{{item.skype}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;" v-if="item.jsfzr">{{languageMap['技术负责人']}}：{{languageMap[item.jsfzr]}}</div>
			</div>
			
          </div>
		</div>

		<div class="gjBg">
			<div style="width: 97%;height: 130px;margin-top: 44px;margin-left: 10px;float: left;">
			  <div v-if="block5_gs">	
				<div style="font-size: 30px;">{{languageMap[block5_gs.title]}}</div>
				<div style="font-size: 14px;color: #565656;margin-top: 25px;">{{languageMap['地址']}}（ADD）：{{languageMap[block5_gs.address]}}</div>
				<div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['电话']}}（TEL）：{{block5_gs.phone}}  <span style="margin-left: 30px;">{{block5_gs.fax}}</span> （{{languageMap['传真']}}）</div>
			  </div>	
			</div>
			
          <div style="width: 97%;height: 185px;margin-top: 55px;margin-left: 10px;float: left;">
			<div class="blockC" style="width: 190px;" v-for="(item,index) in block5" :key="index">
			  <div style="font-size: 14px;color: #565656;margin-top: 0px;">{{languageMap['联系人']}}：{{languageMap[item.contacts]}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['电话']}}：{{item.phone}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">{{languageMap['邮箱']}}：{{item.email}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;">QQ：{{item.qq}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;" v-if="item.skype">Skype：{{item.skype}}</div>
			  <div style="font-size: 14px;color: #565656;margin-top: 17px;" v-if="item.jsfzr">{{languageMap['技术负责人']}}：{{languageMap[item.jsfzr]}}</div>
			</div>
			
          </div>
		</div>

		<div class="right" style="width: 100%;margin-top: 10px;">
        
        <form enctype="multipart/form-data" method="post">
          <input type="hidden" name="action" value="post">
          <input type="hidden" name="diyid" value="1">
          <input type="hidden" name="do" value="2">
          <div class="line" style="width: 49%;float: left;">
            <input type="text" name="name" class="inputText" v-model="from.name" :placeholder="languageMap['您的姓名']">
          </div>
          <div class="line" style="width: 49%;float: right;">
            <input type="text" name="email" class="inputText" v-model="from.email" :placeholder="languageMap['您的邮箱']">
          </div>
          <div class="line" style="width: 100%;float: left;">
            <input type="text" name="bt" class="inputText" v-model="from.title" :placeholder="languageMap['标题']">
          </div>
          <div class="line" style="width: 100%;float: left;">
            <textarea name="nr" class="textArea" v-model="from.content" :placeholder="languageMap['我们能为您做些什么']"></textarea>
          </div>
          <input type="hidden" name="dede_fields" value="name,text;email,text;bt,text;nr,text">
          <input type="hidden" name="dede_fieldshash" value="f34de0eba88646549ae2f733b3d2d519">
          <div class="line" style="width: 100.7%;">
            <input class="inputSub" :value="languageMap['发送']" @click="contactUsAdd" style="color: white !important;">
          </div>
        </form>
      </div>
      <!-- left -->
      <!-- <div class="left">
        <div class="contentTitle"> <span class="title">{{languageMap['明瑞科技']}}</span>
          <div class="sub"></div>
        </div>
      
        <p class="info"></p><div>
	<span style="font-size: 14px"><img alt="" src="/uploads/allimg/141218/1-14121Q24141U4.jpg" style="width: 711px; height: 172px"><br>
	<br>
	<span style="font-size: 16px"><strong>{{languageMap['北京明瑞之光科技有限公司（北京总部）']}}</strong></span><br>
	{{languageMap['地址']}}：{{languageMap['北京市通州区九棵树西路瑞都国际中心1105']}}<br>
	{{languageMap['电话']}}：010-80816559&nbsp;&nbsp;&nbsp; {{languageMap['传真']}}：010-80816559-810&nbsp;&nbsp; {{languageMap['邮箱']}}：info@bj-mrkj.com<br>
	<br>
	<strong>{{languageMap['技术支持工程师']}}：</strong><br>
	<strong>{{languageMap['侯工']}}&nbsp;&nbsp;&nbsp; </strong>{{languageMap['电话']}}：13522133564&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{languageMap['邮箱']}}：hyh@bj-mrkj.com&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; QQ：421491019<br>
	<strong>{{languageMap['熊工']}}&nbsp;&nbsp;&nbsp; </strong>{{languageMap['电话']}}：13930652989&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{languageMap['邮箱']}}：xj@bj-mrkj.com&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; QQ：864541774<br>
	<strong>{{languageMap['乔工']}}&nbsp;&nbsp;&nbsp; </strong>{{languageMap['电话']}}：13552447127&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{languageMap['邮箱']}}：qq@bj-mrkj.com&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; QQ：5283804<br>
	<br>
	<strong>{{languageMap['商务支持']}}：</strong><br>
	<strong>{{languageMap['全工']}} &nbsp; &nbsp;</strong>{{languageMap['电话']}}：15001078375 &nbsp; &nbsp; &nbsp; {{languageMap['邮箱']}}：qrb@bj-mrkj.com&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; QQ：804216530<br>
	<br>
	<strong>{{languageMap['应急/投诉']}}：</strong><br>
	<strong>{{languageMap['李工']}}&nbsp;&nbsp;&nbsp;&nbsp; </strong>{{languageMap['电话']}}：15901505089&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{languageMap['邮箱']}}：lgm@bj-mrkj.com&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; QQ：419897902<br>
	&nbsp;<br>
	<span style="font-size: 16px"><strong>{{languageMap['北京明瑞之光科技有限公司（深圳分公司）']}}</strong></span><br>
	{{languageMap['地址']}}：{{languageMap['深圳市宝安区新安街道宝安7区甲岸商务中心4楼431-432号']}}<br>
	{{languageMap['电话']}}：0755-29744002&nbsp;&nbsp;&nbsp; {{languageMap['传真']}}：0755-29744002&nbsp;&nbsp;<br>
	<br>
	<strong>{{languageMap['朱工']}}</strong>&nbsp;&nbsp;&nbsp;&nbsp; {{languageMap['电话']}}：13530622716&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{languageMap['邮箱']}}：zjc@bj-mrkj.com&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; QQ：634104296<br>
	<strong>{{languageMap['达工']}}</strong> &nbsp; &nbsp; {{languageMap['电话']}}：18320850391 &nbsp; &nbsp; &nbsp;{{languageMap['邮箱']}}：dp@bj-mrkj.com &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; QQ：485908509<br>
	<strong>{{languageMap['夏工']}}</strong>&nbsp; &nbsp; &nbsp;{{languageMap['电话']}}：15220175889 &nbsp; &nbsp; &nbsp;{{languageMap['邮箱']}}：xcy@bj-mrkj.com &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;QQ：3525026915<br>
	&nbsp;</span><br>
	<span style="font-size:16px;"><strong>{{languageMap['北京明瑞之光科技有限公司（上海分公司）']}}</strong></span><br>
	<span style="font-size: 14px">{{languageMap['地址']}}：{{languageMap['上海市松江区谷阳北路1250弄139号301']}}<br>
	{{languageMap['电话']}}：021-67818126&nbsp;&nbsp;&nbsp; {{languageMap['传真']}}：021-67818126&nbsp;&nbsp;<br>
	<br>
	<strong>{{languageMap['熊工']}}</strong> &nbsp; &nbsp; {{languageMap['电话']}}：13524451950 &nbsp; &nbsp; &nbsp;{{languageMap['邮箱']}}：xy@bj-mrkj.com &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;QQ：282517554<br>
	<strong>{{languageMap['王工']}}</strong>&nbsp;&nbsp;&nbsp;&nbsp; {{languageMap['电话']}}：</span><span style="font-size:14px;">18117543208</span><span style="font-size: 14px">&nbsp;&nbsp; &nbsp; &nbsp;{{languageMap['邮箱']}}：wp@bj-mrkj.com&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; QQ：1900136089</span><br>
	<br>
	<span style="font-size: 16px;"><strong>{{languageMap['北京明瑞之光科技有限公司（重庆分公司）']}}</strong></span><br style="font-size: 14px;">
	<span style="font-size: 14px;">{{languageMap['地址']}}：{{languageMap['重庆市渝北区兴盛大道96号吉安园10栋30-6号']}}</span><br style="font-size: 14px;">
	<span style="font-size: 14px;">{{languageMap['电话']}}：023-67959054 &nbsp; &nbsp;{{languageMap['传真']}}：023-67959054 &nbsp;</span><br style="font-size: 14px;">
	<br style="font-size: 14px;">
	<strong style="font-size: 14px;">{{languageMap['潘工']}}</strong><span style="font-size: 14px;">&nbsp;&nbsp;&nbsp;&nbsp; {{languageMap['电话']}}：15223303495 &nbsp; &nbsp; &nbsp;{{languageMap['邮箱']}}：phz@bj-mrkj.com&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;QQ：517414961</span><br style="font-size: 14px;">
	&nbsp;</div>
<br>
<p></p>
     

      </div> -->
      <!-- left over --> 
      <!-- right -->
      <!-- <div class="right">
        <div class="contentTitle"> <span class="title">{{languageMap['联系我们']}}</span>
          <div class="sub"></div>
        </div>
        <form enctype="multipart/form-data" method="post">
          <input type="hidden" name="action" value="post">
          <input type="hidden" name="diyid" value="1">
          <input type="hidden" name="do" value="2">
          <p class="lineTitle">{{languageMap['您的名字（必填）']}}</p>
          <div class="line">
            <input type="text" name="name" class="inputText" v-model="from.name">
          </div>
          <p class="lineTitle">{{languageMap['您的邮箱（必填）']}}</p>
          <div class="line">
            <input type="text" name="email" class="inputText" v-model="from.email">
          </div>
          <p class="lineTitle">{{languageMap['标题']}}</p>
          <div class="line">
            <input type="text" name="bt" class="inputText" v-model="from.title">
          </div>
          <p class="lineTitle">{{languageMap['内容']}}</p>
          <div class="line">
            <textarea name="nr" class="textArea" v-model="from.content"></textarea>
          </div>
          <input type="hidden" name="dede_fields" value="name,text;email,text;bt,text;nr,text">
          <input type="hidden" name="dede_fieldshash" value="f34de0eba88646549ae2f733b3d2d519">
          <div class="line">
            <input class="inputSub" :value="languageMap['发送']" @click="contactUsAdd" style="color: white !important;">
          </div>
        </form>
      </div> -->
      <!-- right over --> 
    </div>

  </div>
</div>
 <Footer></Footer>
</div>
</template>

<style scoped>
input, textarea {
    color: #999999 !important;
    font-size: 15px;
}

.blockC{
	width: 203px;
	height: 100%;
	float: left;
}

.bjBg{
  width: 100%;
  background: url('/images/panel_bj.png') center no-repeat;
  height: 550px;
  background-size: contain;
  float: left;
}
.szBg{
  width: 49%;
  background: url('/images/panel_sz.png') center no-repeat;
  height: 450px;
  background-size: contain;
  margin-top: 10px;
  float: left;
}
.shBg{
  width: 49%;
  background: url('/images/panel_sh.png') center no-repeat;
  height: 450px;
  background-size: contain;
  margin-top: 10px;
  float:right;
}
.cqBg{
  width: 49%;
  background: url('/images/panel_cq.png') center no-repeat;
  height: 450px;
  background-size: contain;
  margin-top: -10px;
  float:left;
}
.gjBg{
  width: 49%;
  background: url('/images/panel_gjb.png') center no-repeat;
  height: 450px;
  background-size: contain;
  margin-top: -10px;
  float:right;
}

/* about.css */
.main .head {
	padding:40px 0;
}
.main .head:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.main .head .left {
	width:590px;
	height:250px;
	float:left;
}
.main .head .left img {
	width:100%;
	height:100%;
	vertical-align:middle;
}
.main .head .right {
	width:500px;
	float:right;
	margin-right:20px;
}
.main .head .right p {
	color:#666;
	font-size:14px;
	line-height:22px;
}
.main .content:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.main .content .contentTitle {
	position:relative;
	line-height:28px;
}
.main .content .contentTitle span {
	position:relative;
	z-index:1;
	color:#333333;
	font-size:18px;
	background:#fff;
	padding-right:12px;
}
.main .content .contentTitle .sub {
	position:absolute;
	top:14px;
	left:0px;
	height:1px;
	background:#d6d6d6;
	width:100%;
}
.main .content .left {
	width:685px;
	float:left;
}
.main .content .left ul {
	margin:18px 0;
	padding-left:20px;
}
.main .content .left li {
	height:28px;
	line-height:28px;
	color:#666;
	font-size:14px;
	list-style:disc;
}
.main .content .left .info {
	color:#666;
	font-size:14px;
	line-height:22px;
	margin:18px 0;
}
.main .content .right {
	width:445px;
	float:right;
}
.main .content .right .contentTitle {
	padding-bottom:30px;
}
.main .content .right .lineTitle {
	padding-top:14px;
	font-size:14px;
	color:#666;
	line-height:32px;
}
.main .content .right .inputText {
	color:#666;
	width:100%;
	height:45px;
	border: none;
	background:#f9f9f9;
	padding-left:12px;
	margin-bottom: 20px;
}
.main .content .right .textArea {
	color:#666;
	width:99%;
	height:143px;
	padding:12px;
	background:#f9f9f9;
	border:none;
}
.main .content .right .inputSub {
	font-size:14px;
	cursor:pointer;
	width:100%;
	height:50px;
	line-height:34px;
	color:#fff;
	background:#0074cf;
	text-align:center;
	margin-top:14px;
	border:0;
}
.main .content .right .inputSub {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.main .content .right .inputSub:hover {
	
}
.main .customer {
	position:relative;
	border-bottom:1px solid #d6d6d6;
}
.main .customer .title {
	line-height:36px;
	color:#333333;
	font-size:18px;
	padding-bottom:20px;
}
.main .customer .customerContent {
	position:relative;
	width:100%;
	height:290px;
	overflow:hidden;
}
.main .customer .customerContent .contents {
	position:absolute;
	top:0px;
	left:0px;
}
.main .customer .customerContent .child {
	position:absolute;
	top:0;
	left:0px;
	width:566px;
	height:290px;
}
.main .customer .customerContent .child .childContent {
	position:relative;
	width:520px;
	height:127px;
	padding:24px;
	background-color:#f1f1f1;
}
.main .customer .customerContent .child .childContent p {
	color:#777777;
	font-size:14px;
	line-height:24px;
}
.main .customer .customerContent .child .childContent .pointer {
	position:absolute;
	bottom:-11px;
	height:11px;
	left:106px;
}
.main .customer .customerContent .child .childFoot {
	position:relative;
	height:80px;
}
.main .customer .customerContent .child .childFoot .childIcon {
	float:left;
	height:80px;
	line-height:80px;
	text-align:center;
}
.main .customer .customerContent .child .childFoot .childIcon img {
	max-height:80px;
	vertical-align:middle;
}
.main .customer .customerContent .child .childFoot .childInfo {
	float:left;
	padding-left:20px;
}
.main .customer .customerContent .child .childFoot .childInfo .childTitle {
	color:#777777;
	font-size:14px;
	line-height:24px;
	padding-top:15px;
}
.main .customer .customerContent .child .childFoot .childInfo .childEn {
	line-height:22px;
	color:#939393;
	font-size:12px;
	font-family:Arial, Helvetica, sans-serif;
}
.main .customer .customerBtn {
	position:absolute;
	bottom:54px;
	cursor:pointer;
	z-index:1;
}
.main .customer .customerBtn.leftBtn {
	right:50px;
}
.main .customer .customerBtn.rightBtn {
	right:0px;
}
.main .customerLogo {
	position:relative;
	padding-top:34px;
}
.main .customerLogo .title {
	line-height:36px;
	color:#333333;
	font-size:18px;
	padding-bottom:36px;
}
.main .customerLogo .customerLogoContent {
	position:relative;
	height:156px;
	width:100%;
	overflow:hidden;
}
.main .customerLogo .customerLogoContent .contents {
	position:absolute;
	top:0px;
	left:0px;
}
.main .customerLogo .customerLogoContent .child {
	position:absolute;
	top:0px;
	width:222px;
	height:154px;
	line-height:154px;
	text-align:center;
	border:1px solid #e2e2e2;
}
.main .customerLogo .customerLogoContent .child {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.main .customerLogo .customerLogoContent .child:hover {
	-webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-ms-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-o-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
}
.main .customerLogo .customerLogoContent .child img {
	vertical-align:middle;
	max-width:90%;
	max-height:90%;
}
.main .customerLogo .logoBtn {
	position:absolute;
	top:164px;
	cursor:pointer;
}
.main .customerLogo .logoBtn.leftBtn {
	left:-60px;
}
.main .customerLogo .logoBtn.rightBtn {
	right:-60px;
}
@media (max-width: 639px) {
.main .head {
	padding:20px 0;
}
.main .head .left {
	width:100%;
	height:auto;
	float:none;
}
.main .head .left img {
	width:100%;
	height:auto;
}
.main .head .right {
	width:100%;
	float:none;
	margin:10px 0;
}
.main .head .right p {
	font-size:12px;
	line-height:18px;
}
.main .content .contentTitle {
	line-height:20px;
}
.main .content .contentTitle span {
	font-size:14px;
	padding-right:8px;
}
.main .content .contentTitle .sub {
	top:10px;
}
.main .content .left {
	width:100%;
	float:none;
}
.main .content .left ul {
	margin:10px 0;
	padding-left:20px;
}
.main .content .left li {
	height:20px;
	line-height:20px;
	font-size:12px;
}
.main .content .left .info {
	font-size:12px;
	line-height:20px;
	margin:10px 0;
}
.main .content .right {
	width:100%;
	float:none;
}
.main .content .right .contentTitle {
	padding-bottom:0px;
}
.main .content .right .lineTitle {
	padding-top:10px;
	font-size:12px;
	line-height:26px;
}
.main .content .right .inputText {
	width:280px;
	height:30px;
	padding-left:6px;
}
.main .content .right .textArea {
	width:274px;
	height:143px;
	padding:6px;
}
.main .content .right .inputSub {
	font-size:12px;
	width:90px;
	height:34px;
	line-height:34px;
	margin-top:14px;
}
.main .customer {
	padding-top:20px;
}
.main .customer .title {
	line-height:24px;
	font-size:14px;
	padding-bottom:10px;
}
.main .customer .customerContent {
	width:100%;
	height:290px;
}
.main .customer .customerContent .contents {
	width:100%;
}
.main .customer .customerContent .child {
	width:100%;
	height:290px;
}
.main .customer .customerContent .child .childContent {
	width:auto;
	height:160px;
	padding:12px;
}
.main .customer .customerContent .child .childContent p {
	font-size:12px;
	line-height:20px;
}
.main .customer .customerContent .child .childContent .pointer {
	bottom:-11px;
	height:11px;
	left:106px;
}
.main .customer .customerContent .child .childFoot {
	height:80px;
}
.main .customer .customerContent .child .childFoot .childIcon {
	height:80px;
	line-height:80px;
}
.main .customer .customerContent .child .childFoot .childIcon img {
	max-height:80px;
}
.main .customer .customerContent .child .childFoot .childInfo {
	padding-left:20px;
}
.main .customer .customerContent .child .childFoot .childInfo .childTitle {
	font-size:14px;
	line-height:24px;
	padding-top:15px;
}
.main .customer .customerContent .child .childFoot .childInfo .childEn {
	line-height:22px;
	font-size:12px;
}
.main .customer .customerBtn {
	bottom:54px;
}
.main .customer .customerBtn.leftBtn {
	right:50px;
}
.main .customer .customerBtn.rightBtn {
	right:0px;
}
.main .customerLogo {
	padding-top:34px;
}
.main .customerLogo .title {
	line-height:36px;
	font-size:18px;
	padding-bottom:36px;
}
.main .customerLogo .customerLogoContent {
	height:77px;
}
.main .customerLogo .customerLogoContent .child {
	width:90px;
	height:75px;
	line-height:75px;
}
.main .customerLogo .logoBtn {
	top:122px;
}
.main .customerLogo .logoBtn.leftBtn {
	left:0px;
}
.main .customerLogo .logoBtn.rightBtn {
	right:0px;
}
}
@media (min-width: 640px) and (max-width:1023px ) {
.main .head {
	padding:40px 0;
}
.main .head .left {
	width:100%;
	height:auto;
	float:none;
}
.main .head .left img {
	width:100%;
	height:auto;
}
.main .head .right {
	width:100%;
	float:none;
	margin:10px 0;
}
.main .head .right p {
	font-size:14px;
	line-height:22px;
}
.main .content .contentTitle {
	line-height:28px;
}
.main .content .contentTitle span {
	font-size:18px;
	padding-right:12px;
}
.main .content .contentTitle .sub {
	top:14px;
}
.main .content .left {
	width:100%;
	float:none;
}
.main .content .left ul {
	margin:18px 0;
	padding-left:20px;
}
.main .content .left li {
	height:28px;
	line-height:28px;
	font-size:14px;
}
.main .content .left .info {
	font-size:14px;
	line-height:22px;
	margin:18px 0;
}
.main .content .right {
	width:100%;
	float:none;
}
.main .content .right .contentTitle {
	padding-bottom:0px;
}
.main .content .right .lineTitle {
	padding-top:14px;
	font-size:14px;
	line-height:32px;
}
.main .content .right .inputText {
	width:90%;
	height:36px;
	padding-left:12px;
}
.main .content .right .textArea {
	width:90%;
	height:143px;
	padding:12px;
}
.main .content .right .inputSub {
	font-size:14px;
	width:90px;
	height:34px;
	line-height:34px;
	margin-top:14px;
}
.main .customer {
	padding-top:20px;
}
.main .customer .title {
	line-height:36px;
	font-size:18px;
	padding-bottom:20px;
}
.main .customer .customerContent {
	width:100%;
	height:290px;
}
.main .customer .customerContent .child {
	width:600px;
	height:290px;
}
.main .customer .customerContent .child .childContent {
	width:552px;
	height:127px;
	padding:24px;
}
.main .customer .customerContent .child .childContent p {
	font-size:14px;
	line-height:24px;
}
.main .customer .customerContent .child .childContent .pointer {
	bottom:-11px;
	height:11px;
	left:106px;
}
.main .customer .customerContent .child .childFoot {
	height:80px;
}
.main .customer .customerContent .child .childFoot .childIcon {
	height:80px;
	line-height:80px;
}
.main .customer .customerContent .child .childFoot .childIcon img {
	max-height:80px;
}
.main .customer .customerContent .child .childFoot .childInfo {
	padding-left:20px;
}
.main .customer .customerContent .child .childFoot .childInfo .childTitle {
	font-size:14px;
	line-height:24px;
	padding-top:15px;
}
.main .customer .customerContent .child .childFoot .childInfo .childEn {
	line-height:22px;
	font-size:12px;
}
.main .customer .customerBtn {
	bottom:54px;
}
.main .customer .customerBtn.leftBtn {
	right:50px;
}
.main .customer .customerBtn.rightBtn {
	right:0px;
}
.main .customerLogo {
	padding-top:34px;
}
.main .customerLogo .title {
	line-height:36px;
	font-size:18px;
	padding-bottom:36px;
}
.main .customerLogo .customerLogoContent {
	height:156px;
}
.main .customerLogo .customerLogoContent .child {
	width:180px;
	height:130px;
	line-height:130px;
}
.main .customerLogo .logoBtn {
	top:154px;
}
.main .customerLogo .logoBtn.leftBtn {
	left:0px;
}
.main .customerLogo .logoBtn.rightBtn {
	right:0px;
}
}
@media (min-width: 1024px) and (max-width:1199px ) {
.main .head {
	padding:40px 0;
}
.main .head .left {
	width:480px;
	height:204px;
}
.main .head .right {
	width:408px;
	margin-right:20px;
}
.main .content .left {
	width:560px;
}
.main .content .right {
	width:362px;
}
.main .content .right .textArea {
	width:340px;
}
.main .customer .title {
	line-height:36px;
	font-size:18px;
	padding-bottom:20px;
}
.main .customer .customerContent {
	height:290px;
}
.main .customer .customerContent .child {
	width:462px;
	height:236px;
}
.main .customer .customerContent .child .childContent {
	width:424px;
	height:103px;
	padding:8px 12px;
}
.main .customer .customerContent .child .childContent p {
	font-size:12px;
	line-height:18px;
}
.main .customer .customerBtn {
	bottom:54px;
}
.main .customer .customerBtn.leftBtn {
	right:50px;
}
.main .customer .customerBtn.rightBtn {
	right:0px;
}
.main .customerLogo {
	padding-top:34px;
}
.main .customerLogo .customerLogoContent {
	height:156px;
}
.main .customerLogo .customerLogoContent .child {
	width:181px;
	height:125px;
	line-height:125px;
}
.main .customerLogo .logoBtn {
	top:150px;
}
.main .customerLogo .logoBtn.leftBtn {
	left:0px;
}
.main .customerLogo .logoBtn.rightBtn {
	right:0px;
}
}
@media (min-width: 1200px) and (max-width:1439px ) {
}
@media (min-width: 1440px) and (max-width:1920px ) {
}


</style>

<script>
import store from "@/store";
import config from "@/config";
import Header from "@/components/front/Header.vue";
import Footer from "@/components/front/Footer.vue";
import NavigationBar from "@/components/front/NavigationBar.vue";

export default {
  data() {
    return {
		from:{
			name:null,
			email:null,
			title:null,
			content:null
		},
      languageMap:{},
			timer: null,
			block1: [],
			block1_gs: null,
			block2: [],
			block2_gs: null,
			block3: [],
			block3_gs: null,
			block4: [],
			block4_gs: null,
			block5: [],
			block5_gs: null
    };
  },
  mounted() {
	//   this.setBgHeight();
	//   let this_ = this; 
	// this.timer = setInterval(function(){
	// 	  this_.setBgHeight();
	//   },1000)

      //查询块数据
	  for(let i=1; i <=5; i++){
		  this.contactusConfigQueryList(i);
	  }
  },
  beforeDestroy(){
	  clearInterval(this.timer)
  },
  methods: {
	  setBgHeight(){
 this.$nextTick(() => {
	 try{
	let offsetHeight = $('#bgId')[0].offsetHeight;
	console.log('offsetHeight='+offsetHeight)
	 $('.bjBg').css('margin-top' , (offsetHeight)+'px')
	 }catch(e){
		 console.log(e)
	 }
 })
	  },
    contactUsAdd(){
		if(!this.from.name){
			this.$message.error(this.languageMap['名字不能为空']);
			return;
		}
		if(!this.from.email){
			this.$message.error(this.languageMap['邮箱不能为空']);
			return;
		}
		var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
		if(!reg.test(this.from.email)){
			this.$message.error(this.languageMap["邮箱格式正确"]);
			return;
		}

		let url =  config.url + "FrontController/contactUsAdd.action";
      this.$http.post(url, this.from).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
			this.$message.success(this.languageMap["已提交"]);
		  this.from={
			name:null,
			email:null,
			title:null,
			content:null
		   }
        }else{
			this.$message.error(data.message);
		}
      }) .catch(err => {
        console.log(err);
      });
	},
   getCookie(name) {  //this.languageMap['获取cookie']
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 },
    getLanguageMap(e){
      this.languageMap=e;
      this.$emit('getLanguageMap',e)
	},
	contactusConfigQueryList(count){
	let url =  config.url + "FrontController/contactusConfigQueryList.action";
	let param={
		bigBlock: count
	}
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
			let list = data.data || [];
			let gsObj = null;
			if(list && list.length > 0 && list[0].type == 1){  //公司信息
				gsObj = list[0];
				list.splice(0, 1); 
			}
			
			if(count==1){
			  this.block1_gs=gsObj;
			  this.block1=list;
			}else if(count==2){
			  this.block2_gs=gsObj;
			  this.block2=list;
			}else if(count==3){
			  this.block3_gs=gsObj;
			  this.block3=list;
			}else if(count==4){
			  this.block4_gs=gsObj;
			  this.block4=list;
			}else if(count==5){
			  this.block5_gs=gsObj;
			  this.block5=list;
			}
        }else{
			this.$message.error(data.message);
		}
      }) .catch(err => {
		this.contactusConfigQueryList(count);
        console.log(err);
      });
	}
  },
  components: {
    Header,
    Footer,
    NavigationBar
  }
};
</script>
